import { PlusSquare } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { NumberParam, useQueryParam } from 'use-query-params';

export function InsertBlockField({ insertIndex }) {
    const { t } = useTranslation();
    const [, setInsertBlockIndex] = useQueryParam('ibi', NumberParam);

    return (
        <div
            data-uk-tooltip={t('documents:document.navbar.main.tooltips.insertBlock')}
            className="insert-block-field show-opacity"
            style={{
                height: 8,
                marginTop: '-0.5rem',
                marginBottom: '2.5rem',
                marginRight: 0,
                marginLeft: -7,
                position: 'relative',
            }}
            onClick={() => setInsertBlockIndex(insertIndex)}
        >
            <PlusSquare size={16} style={{ position: 'absolute', left: -1, top: -4, color: '#0052cc' }} />
            <div className="bg-primary" style={{ position: 'absolute', left: 15, right: 0, top: 3, height: 2 }} />
        </div>
    );
}
